/*********************************************
 * OPTION VALUES
 *********************************************/
export const SET_CURRENT_THEME = 'SET_CURRENT_THEME'
export const SET_CURRENT_CASE = 'SET_CURRENT_CASE'

export const SET_CURRENT_PAGE_INDEX = 'SET_CURRENT_PAGE_INDEX';
export const SET_CURRENT_PAGE_PHASE = 'SET_CURRENT_PAGE_PHASE';
export const CLEAR_PAGE_HISTORY = 'CLEAR_PAGE_HISTORY';
export const SET_IS_READY = 'SET_IS_READY';

export const SET_GAME_CLIENT_CLOSE_REDIRECT_URL = 'SET_GAME_CLIENT_CLOSE_REDIRECT_URL';
export const SET_GAME_CLIENT_TRY_RECONNECT = 'SET_GAME_CLIENT_TRY_RECONNECT';
export const SET_LAST_EMOJI_CODE = 'SET_LAST_EMOJI_CODE';

export const SET_CURRENT_GAME_PHASE = 'SET_CURRENT_GAME_PHASE'

export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const SET_ERROR_ICON = 'SET_ERROR_ICON'
export const SET_ERROR_CALLBACK = 'SET_ERROR_CALLBACK';

export const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE'
export const SET_NAVIGATION_GUARD_ENABLED = 'SET_NAVIGATION_GUARD_ENABLED'
export const SET_GAME_TYPE = 'SET_GAME_TYPE';
export const SET_GAME_CLIENT_TYPE = 'SET_GAME_CLIENT_TYPE';

export const SET_LICENSE = 'SET_LICENSE'
//export const SET_CURRENT_STORY_ID = 'SET_CURRENT_STORY_ID'
//export const SET_START_STORY_ID = 'SET_START_STORY_ID'
//export const SHOW_STORY_CHOICES = 'SHOW_STORY_CHOICES'
